function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.28722 17.846C7.11833 16.5101 5.10214 14.9348 3.27554 13.1491C1.98603 11.8741 1.00122 10.3173 0.396356 8.59762C-0.684394 5.2439 0.573667 1.41109 4.08611 0.273218C5.94004 -0.307392 7.95635 0.0490306 9.50675 1.23142C11.0577 0.0503529 13.0734 -0.305953 14.9274 0.273218C18.4398 1.41109 19.7063 5.2439 18.6256 8.59762C18.0256 10.3157 17.0467 11.8723 15.7633 13.1491C13.935 14.9329 11.9191 16.5079 9.7516 17.846L9.51519 18L9.28722 17.846Z",
  fill: "#FFDD02"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.51036 18L9.28719 17.846C7.11562 16.5102 5.09663 14.935 3.26707 13.1491C1.97144 11.8759 0.980765 10.3189 0.370993 8.59764C-0.701314 5.24392 0.556747 1.41111 4.06919 0.273239C5.92312 -0.307371 7.96602 0.0493242 9.51036 1.24162V18Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M15.419 6.6309C15.2281 6.61865 15.0504 6.52354 14.9275 6.36786C14.8045 6.21217 14.7471 6.0096 14.7687 5.80758C14.7893 5.14219 14.4097 4.53654 13.8242 4.30089C13.4529 4.19983 13.2281 3.79888 13.321 3.40347C13.4091 3.01441 13.7744 2.7725 14.1416 2.86007C14.188 2.86774 14.2326 2.88449 14.2732 2.90947C15.4471 3.35998 16.2072 4.57244 16.1467 5.89814C16.1448 6.09907 16.0662 6.29057 15.929 6.42872C15.7918 6.56687 15.6077 6.63984 15.419 6.6309Z",
  fill: "#2A2A2F"
});

var SvgHeart = function SvgHeart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Heart.09e4dfb1.svg";
export { ForwardRef as ReactComponent };